import React, { useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import MuiSnackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { navActions } from "../../redux/nav";

const useStyles = makeStyles((theme) => ({
  close: {
    padding: theme.spacing(0.5),
  },
}));

function Snackbar({ nav, dispatch }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const message = nav && nav.snackbarOptions && nav.snackbarOptions.message;
    if (message) {
      setOpen(Boolean(message));
    }
    setOpen(false);
  }, [nav]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(navActions.setSnackbarOptions(null));
  };
  const message = nav && nav.snackbarOptions && nav.snackbarOptions.message;
  return (
    <MuiSnackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(message)}
      autoHideDuration={6000}
      onClose={handleClose}
      ContentProps={{
        "aria-describedby": "message-id",
      }}
      message={<span id="message-id">{message && message}</span>}
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          className={classes.close}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
}

Snackbar.propTypes = {
  /** Object containing all snackbar content */
  options: PropTypes.object,
  /** Nav data from Redux store */
  nav: PropTypes.object,
  /** Updates the Redux store */
  dispatch: PropTypes.func,
};

export default connect(store => {
  return {
    nav: store.nav
  };
})(Snackbar);



// WEBPACK FOOTER //
// ./src/components/Snackbar/index.jsx